import React from 'react'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Badge from '@material-ui/core/Badge'
import { withStyles } from '@material-ui/core/styles'
import Styles from '../../../common/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Y from '../../../y18n'
import * as adminActions from '../../../store/admin'

const mapStateToProps = state => ({
  status: state.admin.jobStatus
})

const mapDispatchToProps = dispatch => ({
  adminActions: bindActionCreators(adminActions, dispatch)
})

class HangfireStatus extends React.Component {
  componentDidMount () {
    this.props.adminActions.getJobStatus()
  }

  render () {
    const { classes, status } = this.props

    if(typeof status !== "object") return null
    if (!status || !status.length) return null
    

    const failed = status.filter(x => !x.succeeded)

    return (
      failed.length > 0 &&
      <Paper>
        <div className={classes.content}>
          <div className={classes.textRow}>
            <Badge badgeContent={failed.length} color='error' style={{ margin: 10 }}>
              <Typography variant='title'>
                {Y`Failed to execute scheduled jobs`}
              </Typography>
            </Badge>
            <Typography variant='subheading'>
              {failed.map(x => <div key={x.name}>{Y`${x.description}`}</div>)}
            </Typography>
          </div>
        </div>
      </Paper>
    )
  }
}
HangfireStatus = connect(mapStateToProps, mapDispatchToProps)(HangfireStatus)
export default withStyles(Styles)(HangfireStatus)



// WEBPACK FOOTER //
// ./src/pages/admin/containers/hangfire-status.js